// Lists we use as fallbacks on chains that our backend doesn't support
const CANXIUM_LIST = 'https://raw.githubusercontent.com/canxium/swap-default-token-list/refs/heads/main/all.json'

export const DEFAULT_INACTIVE_LIST_URLS: string[] = [CANXIUM_LIST]
